export default __webpack_public_path__ + "static/media/no_result_icon.f33591cf.svg";